var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.319,
    height: 29.999,
    viewBox: "0 0 26.319 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Notification_Configuration",
    "data-name": "Notification Configuration",
    d: "M8.081,26.443v-.027h7.111a.034.034,0,0,0,0,.012.056.056,0,0,1,0,.014,3.558,3.558,0,0,1-7.116,0ZM1.62,24.5A1.617,1.617,0,0,1,.283,21.972l3.2-4.7V11.4a8.173,8.173,0,0,1,6.551-8V1.6a1.6,1.6,0,1,1,3.2,0V3.406l.089.019.033.007A7.381,7.381,0,0,0,18.1,16.469a7.446,7.446,0,0,0,1.7-.2v1l3.2,4.7a1.627,1.627,0,0,1,.09,1.669,1.61,1.61,0,0,1-1.43.86Zm16.568-9.548a.337.337,0,0,1-.346-.27l-.277-1.793a5.068,5.068,0,0,1-1.176-.676l-1.73.676a.337.337,0,0,1-.415-.135L12.86,10.42a.312.312,0,0,1,.07-.439l1.452-1.116c0-.237-.034-.439-.034-.676s.034-.439.034-.676L12.894,6.4a.41.41,0,0,1-.069-.439l1.384-2.334a.324.324,0,0,1,.415-.135l1.73.676a5.755,5.755,0,0,1,1.176-.676l.277-1.793a.37.37,0,0,1,.346-.27h2.767a.37.37,0,0,1,.345.27l.242,1.793a5,5,0,0,1,1.177.676l1.729-.676a.337.337,0,0,1,.415.135l1.384,2.334a.31.31,0,0,1-.069.439L24.693,7.512c0,.237.034.439.034.676a4.247,4.247,0,0,1-.034.676l1.522,1.116a.408.408,0,0,1,.069.439L24.9,12.755a.324.324,0,0,1-.415.135l-1.73-.676a5.86,5.86,0,0,1-1.176.676L21.3,14.683a.371.371,0,0,1-.346.27ZM17.115,8.188a2.423,2.423,0,1,0,2.422-2.368A2.381,2.381,0,0,0,17.115,8.188Z",
    transform: "translate(0)",
    fill: "#bf55ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationConfiguration);
export default __webpack_public_path__ + "static/media/Notification Configuration.578c9f8dc1d0e2cbee03a9d27e40f10b.svg";
export { ForwardRef as ReactComponent };